<template>
  <v-container class="fill-height">
    <v-row justify="center">
      <v-col cols="12">
        <h1 class="text-center heading">Bienvenido a DIETEC SDR</h1>
        <h3 class="text-center headline">Comienza a ayudar a tus pacientes</h3>
      </v-col>
      <v-col
          cols="12"
          md="11"
          lg="10"
      >
        <v-row justify="center">
          <v-col
              cols="12"
              sm="6"
              md="4"
              v-for="element in navigationMenuItems"
              :key="element.name"
          >
            <v-card
                class="selectable-card"
                color="deep-orange"
                dark
                @click="$router.push(element.route)"
                height="192"
            >
              <v-img
                  :src="getImageUrl(element.imageKey)"
                  height="100%"
                  gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,0.2)"
                  aspect-ratio="1.75"
              >
                <v-card-title class="text-break">
                  <v-icon left large>{{ element.icon }}</v-icon>
                  {{ element.name }}
                </v-card-title>
                <v-card-subtitle>
                  {{ element.description }}
                </v-card-subtitle>
              </v-img>
            </v-card>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "Index",
  data() {
    return {};
  },
  computed: {
    navigationMenuItems() {
      const items = this.$store.getters['permissions/getNavigationMenu']
      return items.filter((item: any) => item.route !== '/')
    },
  },
  methods: {
    getImageUrl(key: string) {
      try {
        return require(`@/assets/images/cards/${key}.webp`);
      } catch (error) {
        return require('@/assets/images/cards/default.webp');
      }
    }
  }
});
</script>

<style>
.navigation-card {
  transition: transform 0.3s ease;
}

.navigation-card:hover {
  transform: translateY(-5px);
}
</style>